export default __webpack_public_path__ + "static/media/diseases_dark.8c531faf.jpeg";